import axios from './../../config/axios';

export function getDimensions(params) {
    return axios().get(`/stock-journal/dimension`, { params })
}

function search(query) {
    return axios().get("/stock-journal/dimensions-search", {
        params: {
            search: query
        }
    });
}

export function getStockIssuedByDimension(params) {
    return axios().get(`/stock-journal/stock-issued-by-dimension`, {
        params: {...params}
    });
}

export default {
    search,
    getDimensions
}